export default {
    SaveCurrentMeetingId(state, data) {
        state.meetingId = data
    },
    SET_CURRENT_HOTEL(state, data) {
        state.currentHotel = data
    },
    SET_CURRENT_ROOM(state, data) {
        state.currentRoom = data
    },
    SaveDevice(state, data) {
        state.isPc = data
    },
    SET_USERINFO(state, data) {
      state.userinfo = data
    },
    SET_REGISTER_PHONE(state, data){
      state.registerMobile = data
      localStorage.setItem('registerMobile', data)
    }
}